import { reactive, ref } from 'vue'

export function createCommonState() {
    return {
        notification: reactive({
            show: false,
            type: '',
            message: '',
            action: null,
            timeout: -1
        }),
        mainLoader: ref(false),
        circularLoader: ref(false),
        updated: ref(false),
        errorCodes: ref([]),
        hasCamera: ref(false),
        selectedListItemId: ref(null),
        savedPagination: reactive({})
    }
}
